import React, {Component} from 'react';
import {Box} from "@material-ui/core";
import {Logo, Title} from "./styled";
import logo from "../../../Assets/logo_login.png";

class StaticElementResetePasswordScreen extends Component {
    render() {
        return (
            <div>
                <Box display={'flex'}
                     justifyContent={'center'}>
                    <Logo src={logo}/>
                </Box>
                <br/>
                <Title variant={'h6'}
                       align={'center'}
                       color={'primary'}>
                    Cadastre uma nova senha
                </Title>
            </div>
        );
    }
}

export default StaticElementResetePasswordScreen;